import { useEffect } from 'react';
import { BigButton } from '../components/ChildFriendly';
import { PERSONA_TYPE_LABELS } from '../api/projects';
import type { PersonaType } from '../api/projects';

interface RoleIntroCardProps {
  roleName: string;
  persona: PersonaType | undefined;
  focus: string;
  onStart: () => void;
}

export function RoleIntroCard({
  roleName, persona, focus, onStart,
}: RoleIntroCardProps) {
  const label = persona ? PERSONA_TYPE_LABELS[persona] : null;
  const emoji = label?.icon ?? '👤';
  const typeLabel = label?.label ?? 'Bilinmiyor';

  // Esc tuşu ile kapat
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onStart();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onStart]);

  return (
    <div
      className="role-intro-backdrop"
      onClick={onStart}
      data-testid="intro-backdrop"
    >
      <div
        className="role-intro-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="intro-title"
        data-persona={persona ?? 'unknown'}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="role-intro-emoji" aria-hidden="true">{emoji}</div>
        <h2 id="intro-title" className="role-intro-title">
          Merhaba! Ben {roleName}
        </h2>
        <span className="role-intro-badge">{typeLabel}</span>
        <p className="role-intro-focus">
          <strong>Beklediğim:</strong> {focus}
        </p>
        <p className="role-intro-hint">
          Kanıtlarını ve önerini paylaşarak ikna etmeye başla.
        </p>
        <BigButton
          variant="primary"
          icon="🚀"
          onClick={onStart}
          fullWidth
          autoFocus
        >
          Başla
        </BigButton>
      </div>
    </div>
  );
}